import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-unit',
  standalone: false,
  templateUrl: './unit.component.html',
  styleUrl: './unit.component.scss'
})
export class UnitComponent implements OnInit, OnDestroy {
  title = 'Unit Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  private subscriptions = new Subscription();
  unit: any[]=[];

  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text', width: '200px' },
    { field: 'code', header: 'Code', filterType: 'text', width: '200px' },
    // { field: 'status', header: 'Status', filterType: 'text', width: '150px' },
  ];
  unitsystem: any;
  selectedunit: any;
  showDeleteDialog: boolean = false;
  viewMode = false;
  selectedUnitData: any = {};

  // Dialog configurations with placeholders
  addDialogConfig: DialogConfig = {
    title: 'Add new Unit',
    width: '800px',
    formLayout: 'single-column',
    fields: [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter unit name (e.g., Infantry Unit)',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'code',
        label: 'Code',
        type: 'text',
        placeholder: 'Enter unit code (e.g., INF001)',
        maxLength: 15,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
      }
    ]
  };

  editDialogConfig: DialogConfig = {
    title: 'Update Unit',
    width: '700px',
    formLayout: 'two-column',
    fields: [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter unit name (e.g., Infantry Unit)',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'code',
        label: 'Code',
        type: 'text',
        placeholder: 'Enter unit code (e.g., INF001)',
        maxLength: 15,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
      }
    ]
  };

  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.getSystem();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/units/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      let resp = res.data || res.results
      this.unit = resp.map((item: any) => ({
        ...item,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
      this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }
  addSystem() {
    this.selectedUnitData = {};
    this.showDialog = true;
  }

  onSubmitAdd(formData: any) {
    let payload = {
      name: formData.name,
      code: formData.code,
      status: 1
    }
    const sub = this.api.postAPI('/master/units/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Unit submitted successfully'
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'failed',
          detail: res.name
        });
      }
    });
    this.subscriptions.add(sub);
  }
viewSystem(unit: any) {
  this.viewMode = true;
  this.editDialogConfig.title = 'View Unit';
  if (unit && unit.id) {
    this.isUpdatedialog = true;
    this.unitsystem = unit;
    this.selectedUnitData = {
      name: unit.name || '',
      code: unit.code || '',
      status: unit.status === 'Active' ? 1 : 0,
    };
  }
}
updateUnit(unit: any): void {
  this.viewMode = false;
  this.editDialogConfig.title = 'Update Unit';
  if (unit) {
    this.isUpdatedialog = true;
    this.unitsystem = unit;
    this.selectedUnitData = {
      name: unit.name || '',
      code: unit.code || '',
      status: unit.status === 'Active' ? 1 : 0,
    };
  } else {
    console.error('No unit data provided for editing');
  }
}
onSubmitEdit(formData: any) {
  let unitId = this.unitsystem.id
  let payload = {
    name: formData.name,
    code: formData.code,
    status: 1
  }
  const sub = this.api.putAPI(`/master/units/${unitId}/`, payload).subscribe((res: any) => {
    if (res) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Unit updated successfully'
      });
      this.isUpdatedialog = false;
      this.getSystem();
    } else {
      this.messageService.add({
        severity: 'failed',
        summary: 'Failed',
        detail: res.detail
      });
    }
  });
  this.subscriptions.add(sub);
}

  onCancelDialog() {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedUnitData = {};
  }

  onCloseDialog() {
    this.showDialog = false;
    this.isUpdatedialog = false;
    this.selectedUnitData = {};
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.unitsystem = equipment
  }

  deleteSystem() {
    // this.unitsystem = unit; // Store selected equipment
    let sectionId = this.unitsystem.id
    const sub = this.api.deleteAPI(`/master/units/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Unit Deleted Successfully',
        });
        // window.location.reload();
        this.showDeleteDialog = false;
        this.getSystem();
      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the Unit. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);

  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/unit', 'Edit') ||
      this.permissionService.hasPrivilege('/master/unit', 'Delete')||
      this.permissionService.hasPrivilege('/master/unit', 'View');
  }
}
